import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/authService';
import { apiClient } from '../services/apiService';

const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated || !projectId) {
      setLoading(false);
      return;
    }

    const loadProject = async () => {
      try {
        setLoading(true);
        setError(null);

        const projRes = await apiClient.get('/api/projects');
        const allProjects = projRes.data || [];
        setProjects(allProjects);

        const active = allProjects.find(p => p.id === projectId);
        if (!active) {
          setError('Project not found');
          navigate('/', { replace: true });
          return;
        }

        setProject(active);
        localStorage.setItem('project_id', projectId);
        localStorage.setItem('active_project_id', projectId);
      } catch (err) {
        console.error('Failed to load project:', err);
        setError(err.message || 'Failed to load project');
      } finally {
        setLoading(false);
      }
    };

    loadProject();
  }, [isAuthenticated, projectId, navigate]);

  const switchProject = (newProjectId) => {
    localStorage.setItem('project_id', newProjectId);
    localStorage.setItem('active_project_id', newProjectId);
    window.location.href = `/p/${newProjectId}/dashboard`;
  };

  const value = {
    project,
    projectId,
    projects,
    switchProject,
    loading,
    error
  };

  return (
    <ProjectContext.Provider value={value}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};
